module.exports = __webpack_public_path__ + "static/sectionafter-41a9a6c7aae9453db992b10007b72f13.png";